import React from 'react';
import { useIntl } from 'react-intl';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from '@doxyme/ui';
import './reset-confirm-modal.scss';
export const ResetConfirmModal = ({ isOpen, onClose, onConfirm, }) => {
    const intl = useIntl();
    const formatMessage = intl.formatMessage.bind(intl);
    return (<Modal ariaLabelledby="reset-confirm-modal" className="reset-confirm-modal" isOpen={isOpen} closeModal={onClose} closeOnOutsideClick>
      <ModalHeader>
        <h4 id="reset-confirm-modal">
          {formatMessage({
            id: 'account.settings.clinic.branding.reset-confirm.title',
        })}
        </h4>
      </ModalHeader>
      <ModalBody>
        {formatMessage({
            id: 'account.settings.clinic.branding.reset-confirm.text',
        })}
      </ModalBody>
      <ModalFooter>
        <div className="ui-modal-actions">
          <Button size="medium" onClick={onClose} btnStyle="outline" color="secondary">
            {formatMessage({ id: 'common.cancel' })}
          </Button>
          <Button size="medium" onClick={onConfirm} color="primary">
            {formatMessage({
            id: 'account.settings.clinic.branding.reset-confirm.confirm',
        })}
          </Button>
        </div>
      </ModalFooter>
    </Modal>);
};
